module.exports = __webpack_public_path__ + "static/media/en-cancel-package_1.7e5acf14.png";